// import { Component, OnInit } from '@angular/core';

// @Component({
//   selector: 'app-admin-elr-view',
//   templateUrl: './admin-elr-view.component.html',
//   styleUrls: ['./admin-elr-view.component.css']
// })
// export class AdminElrViewComponent implements OnInit {

//   constructor() { }

//   ngOnInit(): void {
//   }

// }



import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-admin-elr-view',
  templateUrl: './admin-elr-view.component.html',
  styleUrls: ['./admin-elr-view.component.css']
})
export class AdminElrViewComponent {
  safeUrl: SafeResourceUrl;

  constructor(
    private sanitizer: DomSanitizer,
    private dialogRef: MatDialogRef<AdminElrViewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(data.url);
  }

  close() {
    this.dialogRef.close();
  }

  download() {
    window.open(this.data.url, '_blank');
  }
}
